import React, { Suspense, lazy } from "react";
import LoadingScreen from "./LoadingScreen";

interface LazyComponentWrapperProps {
  children: React.ReactNode;
}

const LazyComponentWrapper: React.FC<LazyComponentWrapperProps> = ({
  children,
}) => {
  return <Suspense fallback={<LoadingScreen />}>{children}</Suspense>;
};

// Helper function to create lazy components with performance monitoring
export const createLazyComponent = <T extends React.ComponentType<any>>(
  importFn: () => Promise<{ default: T }>
) => {
  const LazyComponent = lazy(importFn);

  const WrappedComponent = (props: React.ComponentProps<T>) => (
    <LazyComponentWrapper>
      <LazyComponent {...props} />
    </LazyComponentWrapper>
  );

  return WrappedComponent;
};

export default LazyComponentWrapper;
